import { render, staticRenderFns } from "./CompanyPortfoliosEdit.vue?vue&type=template&id=7e80d2c4&scoped=true&"
import script from "./CompanyPortfoliosEdit.vue?vue&type=script&lang=js&"
export * from "./CompanyPortfoliosEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e80d2c4",
  null
  
)

export default component.exports